import React from "react";
import "./AnnualMaskWorkflowProgress.css";
import { getAnnualMaskWorkflowProgress } from "./annualMaskWorkflowProgressUtils";

const states = {
  complete: { icon: "check-circle", color: "success", label: "Done" },
  pending: { icon: "circle-o", color: "muted", label: "Pending / not recorded" },
  skipped: { icon: "forward", color: "warning", label: "Skipped" },
  failed: { icon: "times-circle", color: "danger", label: "Not passed" },
};

export const AnnualMaskStepStatus = ({ caseItem, step }) => {
  const progress = getAnnualMaskWorkflowProgress(caseItem).find((item) => item.key === step);
  const config = states[progress.state];
  return <span className={`text-${config.color} small annual-mask-step-status`}>
    <i className={`fa fa-${config.icon} mr-1`} aria-hidden="true" />{config.label}
  </span>;
};

const AnnualMaskWorkflowProgress = ({ caseItem }) => (
  <div className="border rounded p-2 mb-3" aria-label="Annual Mask Purchase step progress">
    <div className="font-weight-bold small mb-2">Step progress</div>
    <ol className="annual-mask-step-grid list-unstyled mb-0">
      {getAnnualMaskWorkflowProgress(caseItem).map((step, index) => (
        <li key={step.key} className="annual-mask-step-item small">
          <span>{index + 1}. {step.label}</span>
          <AnnualMaskStepStatus caseItem={caseItem} step={step.key} />
        </li>
      ))}
    </ol>
  </div>
);
export default AnnualMaskWorkflowProgress;
